var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.234 1.13605C12.3914 0.480693 11.2116 0.480693 10.369 1.13605L0.587912 8.74353C-0.289842 9.42623 0.192972 10.8332 1.3049 10.8332H2.46816V20.1665C2.46816 21.4552 3.51283 22.4999 4.80149 22.4999H9.4681V15.4999C9.4681 14.2112 10.5127 13.1665 11.8014 13.1665C13.0901 13.1665 14.1348 14.2112 14.1348 15.4999V22.4999H18.8015C20.0901 22.4999 21.1349 21.4552 21.1349 20.1665V10.8332H22.298C23.4088 10.8332 23.8937 9.42695 23.0151 8.74353L13.234 1.13605Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.9932c7e8c1cedc8dc3b7b171e1dba644.svg";
export { ForwardRef as ReactComponent };